export * from './AbilityIcon.js';
export * from './Achievement.js';
export * from './AmmoCounter.js';
export * from './Avatar.js';
export * from './Badge.js';
export * from './BaseUIComponent.js';
export * from './Button.js';
export * from './Card.js';
export * from './CenterMessage.js';
export * from './ChatMessage.js';
export * from './Compass.js';
export * from './ControlsPanel.js';
export * from './Crosshair.js';
export * from './Input.js';
export * from './InventoryBar.js';
export * from './InventoryGrid.js';
export * from './Keystroke.js';
export * from './Message.js';
export * from './Minimap.js';
export * from './NavItem.js';
export * from './NotificationBadge.js';
export * from './NumberDisplay.js';
export * from './PlayerCard.js';
export * from './ProgressBar.js';
export * from './ReloadIndicator.js';
export * from './StatBar.js';
export * from './Tooltip.js';

import { AbilityIcon } from './AbilityIcon.js';
import { Achievement } from './Achievement.js';
import { AmmoCounter } from './AmmoCounter.js';
import { Avatar } from './Avatar.js';
import { Badge } from './Badge.js';
import { Button } from './Button.js';
import { Card } from './Card.js';
import { CenterMessage } from './CenterMessage.js';
import { ChatMessage } from './ChatMessage.js';
import { Compass } from './Compass.js';
import { ControlsPanel } from './ControlsPanel.js';
import { Crosshair } from './Crosshair.js';
import { Input } from './Input.js';
import { InventoryBar } from './InventoryBar.js';
import { InventoryGrid } from './InventoryGrid.js';
import { Keystroke } from './Keystroke.js';
import { Message } from './Message.js';
import { Minimap } from './Minimap.js';
import { NavItem } from './NavItem.js';
import { NotificationBadge } from './NotificationBadge.js';
import { NumberDisplay } from './NumberDisplay.js';
import { PlayerCard } from './PlayerCard.js';
import { ProgressBar } from './ProgressBar.js';
import { ReloadIndicator } from './ReloadIndicator.js';
import { StatBar } from './StatBar.js';
import { Tooltip } from './Tooltip.js';

import type { UIComponentClass } from './BaseUIComponent.js';

/**
 * Registry of every shipped BaseUIComponent subclass. Each entry must expose a
 * `static metadata: UIComponentMetadata` field. Consumed by the genesys-ui-kit
 * catalog generator and by anything that needs to enumerate engine widgets.
 */
export const UI_COMPONENT_REGISTRY: readonly UIComponentClass[] = [
  AbilityIcon,
  Achievement,
  AmmoCounter,
  Avatar,
  Badge,
  Button,
  Card,
  CenterMessage,
  ChatMessage,
  Compass,
  ControlsPanel,
  Crosshair,
  Input,
  InventoryBar,
  InventoryGrid,
  Keystroke,
  Message,
  Minimap,
  NavItem,
  NotificationBadge,
  NumberDisplay,
  PlayerCard,
  ProgressBar,
  ReloadIndicator,
  StatBar,
  Tooltip,
];
